// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CoinVerticalIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M24.814 7.011C23.305 4.425 21.24 3 19 3h-6c-2.24 0-4.305 1.425-5.814 4.011C5.776 9.428 5 12.625 5 16c0 3.375.776 6.573 2.186 8.989C8.695 27.575 10.76 29 13 29h6c2.24 0 4.305-1.425 5.814-4.011C26.224 22.573 27 19.375 27 16c0-3.375-.776-6.572-2.186-8.989Zm.16 7.989h-4a19.1 19.1 0 0 0-1.21-6h3.823c.765 1.672 1.27 3.75 1.387 6Zm-2.575-8h-3.591a10.39 10.39 0 0 0-1.5-2H19c1.25 0 2.425.75 3.399 2ZM7 16c0-5.963 2.75-11 6-11s6 5.037 6 11c0 5.962-2.75 11-6 11s-6-5.038-6-11Zm12 11h-1.689a10.395 10.395 0 0 0 1.5-2h3.591c-.977 1.25-2.152 2-3.402 2Zm4.587-4h-3.822a19.097 19.097 0 0 0 1.21-6h4c-.117 2.25-.623 4.328-1.388 6Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
